/* eslint-disable no-undef */
/* eslint-disable func-names */
// eslint-disable-next-line func-names
(function($) {
  const helper = {
    // custom helper function for debounce - how to work see https://codepen.io/Hyubert/pen/abZmXjm
    /**
     * Debounce
     * need for once call function
     *
     * @param { function } - callback function
     * @param { number } - timeout time (ms)
     * @return { function }
     */
    debounce(func, timeout) {
      let timeoutID;
      // eslint-disable-next-line no-param-reassign
      timeout = timeout || 200;
      return function() {
        const scope = this;
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        clearTimeout(timeoutID);
        timeoutID = setTimeout(function() {
          func.apply(scope, Array.prototype.slice.call(args));
        }, timeout);
      };
    },
    /**
     * Helper if element exist then call function
     */
    isElementExist(_el, _cb, _argCb) {
      const elem = document.querySelector(_el);
      if (document.body.contains(elem)) {
        try {
          if (arguments.length <= 2) {
            _cb();
          } else {
            _cb(..._argCb);
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
        }
      }
    },

    /**
     *  viewportCheckerAnimate function
     *
     * @param whatElement - element name
     * @param whatClassAdded - class name if element is in viewport
     * @param classAfterAnimate - class name after element animates
     */
    viewportCheckerAnimate(whatElement, whatClassAdded, classAfterAnimate) {
      jQuery(whatElement)
        .addClass('a-hidden')
        .viewportChecker({
          classToRemove: 'a-hidden',
          classToAdd: `animated ${whatClassAdded}`,
          offset: 10,
          callbackFunction(elem) {
            if (classAfterAnimate) {
              elem.on('animationend', () => {
                elem.addClass('animation-end');
              });
            }
          }
        });
    },
    // helpler windowResize
    windowResize(functName) {
      const self = this;
      $(window).on('resize orientationchange', self.debounce(functName, 200));
    },
    /**
     * Init slick slider only on mobile device
     *
     * @param {DOM} $slider
     * @param {array} option - slick slider option
     */
    mobileSlider($slider, option) {
      if (window.matchMedia('(max-width: 768px)').matches) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick(option);
        }
      } else if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    },
    /**
     * Set cookie
     *
     * @param {*} name
     * @param {*} value
     * @param {*} days
     */
    setCookie(name, value, days) {
      let expires = '';
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
      }
      document.cookie = `${name}=${value || ''}${expires}; path=/`;
    },
    /**
     *Get cookie
     *
     * @param {*} name
     * @return {*}
     */
    getCookie(name) {
      const nameEQ = `${name}=`;
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    /**
     * erase cookie
     *
     * @param {*} name
     */
    eraseCookie(name) {
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  };

  const theme = {
    /**
     * Main init function
     */
    init() {
      this.plugins(); // Init all plugins
      this.initHeader(); // Init Header
      this.bindEvents(); // Bind all events
      this.initAnimations(); // Init all animations
      this.initHeroCarousel(); // Init Hero Carousel 2025
    },

    /**
     * Init External Plugins
     */
    plugins() {
      // jcf selector
      jcf.replace('.ajax-filter select', 'Select', {
        wrapNative: false,
        wrapNativeOnMobile: false,
        fakeDropInBody: false
      });
    },

    /**
     * Init header
     */
    initHeader() {
      // Header hamburger
      $('.hamburger').on('click', function() {
        $('.header-nav').toggleClass('is-opened');
        if (!$('.header-nav').hasClass('is-opened')) {
          $('.header-nav__menu').removeAttr('style');
        }
      });

      // Hide search outside of search box
      $(document).click(function(e) {
        e.stopPropagation();
        const search = $('.header-nav__search');
        const search_box = $('.search-box');
        const searchBtn = document.querySelector('.btn-search');
        // check if the clicked area is dropDown or not
        if (
          search.has(e.target).length === 0 &&
          search_box.has(e.target).length === 0 &&
          searchBtn !== e.target
        ) {
          $('.header-nav__search').removeClass('active');
        }
      });

      // Header Search Form
      $('.header-nav__search__icon').on('click', function() {
        $('.header-nav__search').toggleClass('active');
      });

      // mobile nav show child menus
      $('.header-nav__menu > .menu-item-has-children > a').on(
        'click touchstart',
        function(e) {
          if (window.matchMedia('(max-width: 1023px)').matches) {
            e.preventDefault();
            $('.header-nav__menu').css('transform', 'translateX(-100%)');
            $(this)
              .closest('.menu-item-has-children')
              .addClass('is-opened');
            $('.header-logo').hide();
            $('.mobile-nav-back').show();
            return false;
          }
        }
      );
      //
      $('.mobile-nav-back').on('click touchstart', function(e) {
        $('.header-nav__menu').css('transform', 'translateX(0)');
        $('.menu-item-has-children.is-opened').removeClass('is-opened');
        $('.header-logo').show();
        $('.mobile-nav-back').hide();
        return false;
      });
      // toggle 3rd menu
      $('.sub-menu-item-has-children > a').on('click touchstart', function(e) {
        if (window.matchMedia('(max-width: 1023px)').matches) {
          e.preventDefault();
          const $parent = $(this).closest('.sub-menu-item');
          $(this).toggleClass('is-opened');
          $('ul', $parent).slideToggle();
          return false;
        }
      });
      // Update position of children menu
      function resizeHeaderDropdown() {
        if (window.matchMedia('(min-width: 1024px)').matches) {
          const logo = $('.header-nav').offset().left;
          const width = $('.menu-item-has-children')
            .find('.menu-item-link')
            .offset().left;
          $('.sub-menu-content').css('width', `calc(100% - ${width - 30}px)`);
          $('.sub-menu-content').css('left', width);
          $('.sub-menu-content').css('max-width', 1440 - 2 * (width - logo));
        } else {
          $('.sub-menu-content').removeAttr('style');
        }
      }
      resizeHeaderDropdown();
      $(window).on('resize', function() {
        resizeHeaderDropdown();
      });
    },
    /**
     * Bind all events here
     *
     */
    bindEvents() {
      const self = this;

      /** * Run on Document Ready ** */
      $(document).on('ready', function() {
        self.smoothScrollLinks();

        helper.isElementExist('.previous-clients__logos', theme.initPartners);
        helper.isElementExist(
          '.image-content-carousel',
          theme.initImageContentCarousel
        );
        helper.isElementExist(
          '.testimonial-carousel',
          theme.initTestimonialCarousel
        );
        helper.isElementExist('.case-carousel', theme.initCaseCarousel);
        helper.isElementExist('.consultant-items', theme.initConsultCarousel);
        helper.isElementExist('.tab-image', theme.initTabImage);
        helper.isElementExist('.wwa-slides', theme.initWWA);
        helper.isElementExist('.accordion', theme.initAccordion);
        helper.isElementExist('.tab', theme.initTab);
        helper.isElementExist('.cpt-grid', theme.initCPT);
        helper.isElementExist('.full-video', theme.initVideo);
        helper.isElementExist('.topics-block', theme.topicBlock);
        helper.isElementExist('.ajax-filters', theme.initAjaxFilters);

        // Scroll To Top
        $('.scroll_to_top').on('click', function() {
          $('html, body').animate(
            {
              scrollTop: 0
            },
            800
          );
        });

        // header search toggler
        $('.btn-search').on('click', function() {
          $('.header-nav__search').toggleClass('active');
        });

        // popup close
        $('.popup').each(function() {
          const id = $(this).attr('id');
          if (!helper.getCookie(id)) {
            $(this).fadeIn();
          }
        });
        $('.popup-close').on('click', function() {
          const $popup = $(this).closest('.popup');
          const id = $popup.attr('id');
          $popup.fadeOut();
          helper.setCookie(id, 1, 2);
        });
      });
      /** * Run on Window Load ** */
      $(window).on('scroll', function() {
        if ($(window).scrollTop() >= 50)
          $('.header').addClass('header--sticky');
        else $('.header').removeClass('header--sticky');
      });
    },

    /**
     * init scroll revealing animations function
     */
    initAnimations() {
      helper.viewportCheckerAnimate('.a-up', 'fadeInUp', true);
      helper.viewportCheckerAnimate('.a-down', 'fadeInDown');
      helper.viewportCheckerAnimate('.a-left', 'fadeInLeft');
      helper.viewportCheckerAnimate('.a-right', 'fadeInRight');
      helper.viewportCheckerAnimate('.a-op', 'fade');
    },

    /**
     * Smooth Scroll link
     */
    smoothScrollLinks() {
      $('a[href^="#"').on('click touchstart', function() {
        const target = $(this).attr('href');
        if (target !== '#' && $(target).length > 0) {
          const offset = $(target).offset().top - $('header').outerHeight();
          $('html, body').animate(
            {
              scrollTop: offset
            },
            500
          );
        }
        return false;
      });
    },

    /**
     * init Partners section
     */
    initPartners() {
      helper.mobileSlider($('.previous-clients__logos'), {
        slidesToScroll: 1,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '25%',
        dots: true
      });
    },
    /**
     * init image content carousel
     */
    initImageContentCarousel() {
      $('.image-content-carousel').each(function() {
        if ($('.carousel-item', this).length > 1) {
          $(this).slick({
            dots: true,
            arrows: true
          });
        }
      });
    },
    /**
     * init testimonial carousel
     */
    initTestimonialCarousel() {
      $('.testimonial-carousel').each(function() {
        if ($('.testimonial-carousel__item', this).length > 1) {
          $(this).slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: true
          });
        }
      });
    },
    /**
     * init testimonial Carousel
     */
    initCaseCarousel() {
      $('.case-carousel').each(function() {
        if ($('.case-carousel__item', this).length > 1) {
          $(this).slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: true,
            speed: 1000
          });
        }
      });
    },
    /**
     * init consult carousel
     */
    initConsultCarousel() {
      $('.consultant-items').each(function() {
        if ($('.loop-consultant', this).length > 1) {
          $(this).slick({
            arrows: false,
            dots: false,
            slidesToScroll: 1,
            slidesToShow: 4,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToScroll: 1,
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToScroll: 1,
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 640,
                settings: {
                  slidesToScroll: 1,
                  slidesToShow: 1,
                  centerMode: true,
                  centerPadding: '16%'
                }
              }
            ]
          });
        }
      });
    },
    /**
     * init Tab Image
     */
    initTabImage() {
      $('.tab-tab_heading').on('click', function() {
        $('.tab-tab_heading').removeClass('active');
        $('.tab-image__img').removeClass('active');
        $('.tab-main').removeClass('active');
        $(this).addClass('active');
        const target = $(this).attr('data-target');
        const index = $(this).index();
        $(target).addClass('active');
        $('.tab-image__img')
          .eq(index)
          .addClass('active');
      });
    },
    /**
     * init Who We Are
     */
    initWWA() {
      const $slider = $('.wwa-slides');
      const option = {
        arrows: false,
        dots: false,
        variableWidth: true,
        autoplay: true
      };
      if (window.matchMedia('(min-width: 769px)').matches) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick(option);
        }
      } else if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      helper.windowResize(theme.initWWA);
    },
    /**
     * init accordion
     */
    initAccordion() {
      $('.accordion').each(function() {
        const $accordion = $(this);
        $('.accordion-title', this).on('click', function() {
          let flag = false;
          if ($accordion.hasClass('is-active')) flag = true;
          $('.accordion').removeClass('is-active');
          $('.accordion-content').slideUp();
          if (!flag) {
            $accordion.addClass('is-active');
            $('.accordion-content', $accordion).slideDown();
          }
        });
      });
    },
    /**
     * init tab
     */
    initTab() {
      // toggle tab
      $('.tab-link').on('click', function() {
        const target = $(this).attr('data-target');
        if ($(this).hasClass('is-active')) return;
        $('.tab-link.is-active').removeClass('is-active');
        $('.tab-content.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        $(target).addClass('is-active');
        return false;
      });
      // tab all
      $('.tab-all').on('click', function() {
        $('.tab-content').addClass('is-active');
      });
    },
    /**
     * init ajax filters
     *
     */
    initAjaxFilters() {
      // filter search toggler
      $('.ajax-search__btn').on('click', function() {
        $(this).toggleClass('is-active');
        $('.ajax-search__box').toggleClass('is-active');
      });
      // toggle filter search
      $('.ajax-filters__popup__btn, .search-filters__popup__close').on(
        'click',
        function() {
          $('.search-filters__popup').toggleClass('is-active');
        }
      );
      // show child filters
      $('.search-filters__group__toggler').on('click', function() {
        const $parent = $(this).closest('.search-filters__group');
        $('.search-filters__group--child', $parent).toggleClass('is-active');
        $('.search-filters__popup__back').toggleClass('is-active');
      });
      // back to parent filters
      $('.search-filters__popup__back').on('click', function() {
        $(this).toggleClass('is-active');
        $('.search-filters__group--child.is-active').removeClass('is-active');
      });
      // clear all filters
      $('.search-filters__popup__clear').on('click', function() {
        $('.search-filter__btn').removeClass('is-active');
        $('.search-filter__btns .search-filter__btn:first-child').addClass(
          'is-active'
        );
        $('.cpt-grid').removeAttr('data-sort');
        $('.cpt-grid').removeAttr('data-cat');
        $('.cpt-grid').removeAttr('data-user');
        $('.cpt-grid').removeAttr('data-industry');
        $('.cpt-grid').removeAttr('data-topic');
      });
      $(document).on('facetwp-refresh', function() {
        $('html, body').animate(
          {
            scrollTop:
              $('.cpt-grid').offset().top -
              $('header').outerHeight() -
              $('.ajax-filters').outerHeight() -
              50
          },
          'fast'
        );
      });
    },
    /**
     * init cpt
     * */
    initCPT() {
      const $grid = $('.cpt-grid');
      const $paginationWrapper = $('.pagination');
      const $pagination = $('.pagination-numbers');
      const $prevBtn = $('.pagination-prev a');
      const $nextBtn = $('.pagination-next a');
      // ajax cpt function
      function ajaxCPT(loadmore = false) {
        const cat = $grid.attr('data-cat');
        const paged = $grid.attr('data-paged');
        const postsPerPage = $grid.attr('data-posts-per-page');
        const type = $grid.attr('data-post');
        const sort = $grid.attr('data-sort');
        const user = $grid.attr('data-user');
        const industry = $grid.attr('data-industry');
        const topic = $grid.attr('data-topic');
        const s = $grid.attr('data-s');
        $.ajax({
          url: ajaxurl,
          type: 'POST',
          data: {
            action: 'ajax_cpt',
            cat,
            paged,
            type,
            sort,
            user,
            industry,
            topic,
            s,
            posts_per_page: postsPerPage
          },
          beforeSend() {
            if (type != 'person') {
              $('html, body').animate(
                {
                  scrollTop:
                    $grid.offset().top -
                    $('header').outerHeight() -
                    $('.ajax-filters').outerHeight() -
                    50
                },
                500
              );
            }
            $grid.html(
              '<div class="lds-wrapper"><div class="lds-dual-ring"></div></div>'
            );
            $paginationWrapper.hide();
          },
          success(res) {
            const data = JSON.parse(res);
            $('.lds-wrapper').remove();
            $grid.html(data.output);
            if (data.max_num_pages > 1) {
              $pagination.html(data.pagination);
              $paginationWrapper.show();
            }
            $prevBtn.removeAttr('disabled');
            $nextBtn.removeAttr('disabled');
            if (paged == 1) {
              $prevBtn.attr('disabled', true);
            }
            if (paged == data.max_num_pages) {
              $nextBtn.attr('disabled', true);
            }
          },
          complete() {}
        });
      }

      // click category
      $('.cpt-filter').on('click', function() {
        if ($(this).hasClass('is-active')) return;
        const cat = $(this).attr('data-cat');
        $('.cpt-filter.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        $grid.attr('data-paged', 1);
        $grid.attr('data-cat', cat);
        ajaxCPT();
      });

      // select filters
      $('.ajax-filter select').on('change', function() {
        const attribute = `data-${$(this).attr('name')}`;
        const val = $(this).val();
        $grid.attr(attribute, val);
        $grid.attr('data-paged', 1);
        ajaxCPT();
      });

      // search cpt
      $('.ajax-search__input').on('keyup', function(e) {
        if (e.keyCode === 13) {
          const search = $(this).val();
          $grid.attr('data-paged', 1);
          $grid.attr('data-s', search);
          $('.ajax-search__btn.is-active').removeClass('is-active');
          $('.ajax-search__box.is-active').removeClass('is-active');
          ajaxCPT();
        }
      });

      // filter btns
      $('.search-filter__btn').on('click', function() {
        const $buttons = $(this).closest('.search-filter__btns');
        const target = $(this).attr('data-target');
        const value = $(this).attr(target);
        if ($(this).hasClass('is-active')) return;
        $('.search-filter__btn.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        $grid.attr(target, value);
        $grid.attr('data-paged', 1);
      });

      // pagination
      $(document).on('click', 'a.page-numbers', function(e) {
        e.preventDefault();
        if ($(this).hasClass('current')) return;
        $grid.attr('data-paged', $(this).html());
        ajaxCPT();
      });
      // prev pagination
      $prevBtn.on('click', function(e) {
        e.preventDefault();
        let paged = parseInt($grid.attr('data-paged'));
        paged -= 1;
        $grid.attr('data-paged', paged);
        ajaxCPT();
      });
      // next pagination
      $nextBtn.on('click', function(e) {
        e.preventDefault();
        let paged = parseInt($grid.attr('data-paged'));
        paged += 1;
        $grid.attr('data-paged', paged);
        ajaxCPT();
      });

      // confirm filters
      $('.search-filters__popup__apply').on('click', function() {
        $('.search-filters__popup').removeClass('is-active');
        ajaxCPT();
      });
    },
    /**
     * init video
     */
    initVideo() {
      $('.full-video__play').on('click', function() {
        const $parent = $(this).closest('.full-video');
        const $iframe = $('iframe', $parent);
        $video = $('video', $parent);
        if ($iframe.length > 0) {
          const symbol = $iframe[0].src.indexOf('?') > -1 ? '&' : '?';
          // modify source to autoplay and start video
          $iframe[0].src += `${symbol}autoplay=1`;
        } else if ($video.length > 0) {
          $video.get(0).play();
        }
        $(this).hide();
      });
    },
    /**
     * show tabs on hover
     */
    topicBlock() {
      // toggle tab
      $('.topics-block .tab-link').hover(function() {
        const target = $(this).attr('data-target');
        if ($(this).hasClass('is-active')) return;
        $('.tab-link.is-active').removeClass('is-active');
        $('.tab-content.is-active').removeClass('is-active');
        $(this).addClass('is-active');
        $(target).addClass('is-active');
        return false;
      });
    },
    /**
     * Init Hero Carousel 2025
     */
    initHeroCarousel() {
      // Check if Swiper is available and hero carousel exists
      if (typeof Swiper === 'undefined' || !document.querySelector('.hero-carousel-2025 .swiper')) {
        return;
      }

      // Initialize all hero carousels on the page
      document.querySelectorAll('.hero-carousel-2025 .swiper').forEach(function(swiperElement) {
        // Skip if only one slide (no need for carousel)
        if (swiperElement.closest('.hero-carousel-2025').classList.contains('single-slide')) {
          return;
        }

        // Get data attributes
        const autoplayEnabled = swiperElement.dataset.autoplay === 'true';
        const autoplayDelay = parseInt(swiperElement.dataset.autoplayDelay) || 5000;
        const loopEnabled = swiperElement.dataset.loop === 'true';

        // Debug logging
        console.log('Hero Carousel Debug:', {
          elementId: swiperElement.id,
          autoplayDataAttr: swiperElement.dataset.autoplay,
          autoplayEnabled: autoplayEnabled,
          autoplayDelay: autoplayDelay,
          loopDataAttr: swiperElement.dataset.loop,
          loopEnabled: loopEnabled,
          isMobile: window.matchMedia('(max-width: 768px)').matches
        });

        // Build Swiper configuration
        const swiperConfig = {
          slidesPerView: 1,
          spaceBetween: 0,
          direction: 'horizontal',
          loop: loopEnabled,
          effect: 'slide',
          speed: 600,
          autoplay: false, // Explicitly disable autoplay by default
          navigation: {
            nextEl: `#${swiperElement.id} .swiper-button-next`,
            prevEl: `#${swiperElement.id} .swiper-button-prev`,
          },
          pagination: {
            el: `#${swiperElement.id} .swiper-pagination`,
            clickable: true,
          },
          breakpoints: {
            768: {
              spaceBetween: 0,
            },
            1024: {
              spaceBetween: 0,
            },
          },
        };

        // Add autoplay if enabled (but not on mobile)
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        if (autoplayEnabled && !isMobile) {
          swiperConfig.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        // Initialize Swiper
        new Swiper(`#${swiperElement.id}`, swiperConfig);
      });
    }
  };

  // Initialize Theme
  theme.init();
})(jQuery);
